import { initialPopup } from 'hooks/constants'
import { PopupReturnTypeWithPayload } from 'hooks/usePopup'
import { GenerateResolutionLinkPopupPayload } from './types'

export const TABS_OPTIONS = [
  { label: 'Community details', value: 'general' },
  { label: 'Health systems', value: 'health_systems' }
]
export const TABS_OPTIONS_CP = [
  { label: 'Community details', value: 'general' },
  { label: 'Users', value: 'users' },
  { label: 'Health systems', value: 'health_systems' },
  { label: 'Banking setup', value: 'banking_setup' },
  { label: 'Bank accounts', value: 'bank_accounts' }
]

export const generateResolutionLinkPopupWithPayload: PopupReturnTypeWithPayload<GenerateResolutionLinkPopupPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: {
        uuid: ''
      }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }

export const resolutionLinkGeneratedPopupWithPayload: PopupReturnTypeWithPayload<{}> =
  {
    state: {
      ...initialPopup?.state,
      payload: {
        link: '',
        expires_on: ''
      }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }
